import { getLicense } from "./getLicense";

const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1oQ846KD4S3m9/L3iG0Y
eGpemzywOTPQRx0Octtus7CFubz92iM9f1M0OKqGplfAw7NW2h+1cwtneYxH/Ghc
Mc4S2dn5gOGUV1W6Xb01zkVIPWaaA/QGbuxaQNGnkLYsXCAfMAeAzkaV9hQa35v8
UbxMQ6Fd8g4vRgJKu6bwru3G/0R6VVxrbToyQF2jtTXrQ5DKAD78MoyGLGgcvh++
3VvVlVXAI4B8Jj/vYGHJzdUfcNNOI/ngCogeHBE/JTXbeeAZmhMLze+b7OAZj2zP
ok8omL0Bj7FTiYA5eDP9+7TXRPALMIwiPhSBxs9JrGKYmjcy02pvHEoY/XFavbky
YwIDAQAB
-----END PUBLIC KEY-----
`;

export const verifyLicenseWebCrypto = async () => {
  try {
    const token = getLicense("token=");
    if (!token) return false;

    const { id, name, expired, signature, pay, workName, store, logo, currency } = token;
    const payload = `id=${id}|name=${name}|expired=${expired}|pay=${pay}|workName=${workName}|store=${store}|logo=${logo}|currency=${currency}`;
    const publicKey = await importPublicKey(PUBLIC_KEY);
    
    const signatureBuffer = base64ToArrayBuffer(signature);
    
    const encoder = new TextEncoder();
    const payloadBuffer = encoder.encode(payload);
    
    const isValid = await window.crypto.subtle.verify(
      {
        name: "RSASSA-PKCS1-v1_5",
        hash: { name: "SHA-256" }
      },
      publicKey,
      signatureBuffer,
      payloadBuffer
    );
    const isExpired = new Date(expired).getTime() < Date.now();
    return {
      isValid: isValid,
      isExpired: !isExpired
    };
    
  } catch (error) {
    console.error("Web Crypto error:", error);
    return false;
  }
};

async function importPublicKey(pem) {
  const pemHeader = "-----BEGIN PUBLIC KEY-----";
  const pemFooter = "-----END PUBLIC KEY-----";
  const pemContents = pem
    .replace(pemHeader, "")
    .replace(pemFooter, "")
    .replace(/\s/g, "");
  
  const binaryDer = base64ToArrayBuffer(pemContents);
  
  return await window.crypto.subtle.importKey(
    "spki",
    binaryDer,
    {
      name: "RSASSA-PKCS1-v1_5",
      hash: { name: "SHA-256" }
    },
    true,
    ["verify"]
  );
}

function base64ToArrayBuffer(base64) {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}